const selectedItemsList = {
  display: 'flex',
  flexWrap: 'wrap',
  maxWidth: '480px',
};

export { selectedItemsList };
